var map = {
	"./music-instructions.json": 4892,
	"./music-library-intro2024.json": 4893,
	"./music-library-launch2024.json": 4894,
	"./music-progression.json": 4895,
	"./startSourcesAdvanced.json": 4896,
	"./startSourcesSimple.json": 4897,
	"./startSourcesSimple2.json": 4898,
	"./startSourcesTracks.json": 4899
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4531;